import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Pagination from "react-js-pagination";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
class RelatorioAgenda extends Component {
  constructor() {
    super();
    this.load = this.load.bind(this);
    this.upload = this.upload.bind(this);
    this.dataPK = this.dataPK.bind(this);
    this.onChange = this.onChange.bind(this);
    this.paginar = this.paginar.bind(this);
    this.onPeriodInicial = this.onPeriodInicial.bind(this);
    this.onPeriodFim = this.onPeriodFim.bind(this);
    this.pesquisa = this.pesquisa.bind(this);
    this.clickPedido = this.clickPedido.bind(this);
    this.toggle = this.toggle.bind(this);

    this.state = {
      pequisa: false,
      periodoFinal: moment().endOf("month").toDate(), //moment(Date()).format('DD/MM/YYYY'),
      periodoInicial: moment().startOf("month").toDate(), //moment(Date()).format('DD/MM/YYYY'),
      agendas: [],
      dtinicial: false,
      dtFinal: false,
      motivo: "",
      produtos: [],
      agendasBkp: [],
      motivosFinalizacao: [],
      motivoSelecionado: null,
      paginacao: {
        pagina: 1,
        limite: 10,
      },
      totalizador: 0,
      modal: true,
    };
  }

  async componentDidMount() {
    await this.load();
    await this.loadMotivosFinalizacao();
  }

  async upload() {
    let agendas = this.state.agendas;
    let skey = "";
    if (agendas.length) {
      await axios
        .post(
          `${this.props.getBaseUrlApi()}/relatorios/pdf`,
          { agendas },
          this.props.parameters()
        )
        .then((response) => {
          skey = response.data.relatorio;
        })
        .catch((error) => {
          console.log(error);
          if (error.response !== undefined) {
            if (error.response.status === 401) {
              this.props.logout();
            }
          }
        });
      let myWindow = window.open("", "_blank", "myWindow");
      myWindow.document.write(`${skey}`);
    } else {
      alert("Não existe nem uma agenda na lista para criar o relatório");
    }
  }

  async onChange(e) {
    let agendas = this.state.agendasBkp;
    let agendasFiltradas = [];
    if (agendas.length) {
      agendasFiltradas = agendas.filter(function (key) {
        if (key.motivoFinalizacao && key.motivoFinalizacao.desc == e.value)
          return key;
      });
    }
    this.setState({
      motivoSelecionado: e,
      agendas: agendasFiltradas,
      motivo: e.value,
    });
  }

  async load() {
    let periodo = {};
    periodo.ini = this.state.periodoInicial.toISOString();
    periodo.fim = this.state.periodoFinal.toISOString();
    let agends = [];
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/relatorios/agendas?final=${
          periodo.fim
        }&inicial=${periodo.ini}&motivo=${this.state.motivo}`,
        this.props.parameters()
      )
      .then((response) => {
        if (response.data.agendas.length > 0) agends = response.data.agendas;
      }).catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
           this.props.logout()
          }
        }
      });
    this.setState(
      { agendas: agends, totalizador: agends.length, agendasBkp: agends },
      () => {
        this.paginar(1);
      }
    );
  }

  async loadMotivosFinalizacao() {
    let motivos = [];
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/relatorios/motivos`,
        this.props.parameters()
      )
      .then((response) => {
        motivos = response.data.motivos;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
    let newMotivos = [];
    for (let aux of motivos) {
      newMotivos.push({
        value: aux.desc,
        label: aux.desc,
        descricao: aux.desc,
      });
    }
    this.setState({ motivosFinalizacao: newMotivos });
  }

  async dataPK(escolha) {
    let inicio = this.state.dtinicial;
    let final = this.state.dtFinal;
    if (escolha == "inicial") {
      if (!inicio) inicio = true;
      else inicio = false;
      this.setState({ dtinicial: inicio });
    } else {
      if (!final) final = true;
      else final = false;
      this.setState({ dtFinal: final });
    }
  }

  paginar(paginaAlterar) {
    this.setState({ paginacao: { pagina: paginaAlterar, limite: 10 } }, () => {
      let agendas = [...this.state.agendasBkp];
      paginaAlterar = paginaAlterar - 1;
      agendas = agendas.slice(
        paginaAlterar * this.state.paginacao.limite,
        (paginaAlterar + 1) * this.state.paginacao.limite
      );
      paginaAlterar = paginaAlterar + 1;

      this.setState({ agendas });
    });
  }

  onPeriodInicial(e) {
    this.setState({ periodoInicial: e }, () => this.dataPK("inicial"));
  }

  onPeriodFim(e) {
    this.setState({ periodoFinal: e }, () => this.dataPK("final"));
  }

  async pesquisa() {
    this.setState({ pesquisa: true });
  }

  async clickPedido(pedido) {
    this.props.history.push(`/pedido-detalhe?id=${pedido}`);
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Consulta de Agendas" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"relatorio-agenda"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Relatório de agendas"
                  description="Gera relatório no período selecionado."
                /> */}
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  onClick={() => {
                                    this.dataPK("inicial");
                                  }}
                                  alt="logo"
                                  className="mr-3 mx-3 cal-agenda"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período Inicial
                                  </small>
                                  <div className="rel-age">
                                    {this.state.dtinicial && (
                                      <DatePicker
                                        selected={this.state.periodoInicial}
                                        onChange={(date) =>
                                          this.onPeriodInicial(date)
                                        }
                                        inline
                                        locale="pt-BR"
                                      />
                                    )}
                                  </div>
                                  <small
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      this.dataPK("inicial");
                                    }}
                                  >
                                    {moment(this.state.periodoInicial).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </small>
                                </div>
                              </div>
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  onClick={() => {
                                    this.dataPK("final");
                                  }}
                                  alt="logo"
                                  className="mr-3 mx-3 cal-agenda"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período Final
                                  </small>
                                  <div className="rel-age">
                                    {this.state.dtFinal && (
                                      <DatePicker
                                        selected={this.state.periodoFinal}
                                        onChange={(date) =>
                                          this.onPeriodFim(date)
                                        }
                                        inline
                                        locale="pt-BR"
                                      />
                                    )}
                                  </div>

                                  <small
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      this.dataPK("final");
                                    }}
                                  >
                                    {moment(this.state.periodoFinal).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </small>
                                </div>
                              </div>
                              <div
                                className="col-lg-4"
                                style={{ marginTop: "1.2em" }}
                              >
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Motivo
                                  </small>
                                  <Select
                                    options={this.state.motivosFinalizacao}
                                    value={this.state.motivoSelecionado}
                                    onChange={(motivoSelecionado) =>
                                      this.onChange(motivoSelecionado)
                                    }
                                    placeholder="Selecione"
                                  />
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <div className="d-flex flex-column justify-content-around">
                                  <small
                                    className="mb-1 text-muted"
                                    style={{ height: "20px" }}
                                  ></small>
                                  <button
                                    className="mr-2 mb-0 btn btn-primary"
                                    onClick={() => {
                                      this.load();
                                      this.pesquisa();
                                    }}
                                  >
                                    Filtrar
                                  </button>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <div className="d-flex flex-column justify-content-around">
                                  <small
                                    className="mb-1 text-muted"
                                    style={{ height: "20px" }}
                                  ></small>
                                  <button
                                    className="mr-2 mb-0 btn btn-danger"
                                    onClick={() => this.upload()}
                                  >
                                    Gerar PDF
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 stretch-card">
                    {this.state.agendas.length > 0 && (
                      <div className="card">
                        <div className="card-body">
                          <div className="table-responsive">
                            {this.state.agendas.length > 0 && (
                              <table
                                id="recent-purchases-listing"
                                className="table"
                              >
                                <thead>
                                  <tr>
                                    <th style={{ textAlign: "center" }}>
                                      Data
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Horário
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Pessoa
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Ação
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Pedido
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Finalizada com sucesso
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Motivo
                                    </th>
                                    <th style={{ textAlign: "center" }}>
                                      Ações
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.agendas.map((agenda, key) => (
                                    <tr key={key}>
                                      <td style={{ textAlign: "center" }}>
                                        {moment(agenda.data).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {agenda.horario
                                          ? `${agenda.horario}`
                                          : " - "}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <span
                                          style={
                                            {
                                              // textDecoration: "underline",
                                              // cursor:"pointer"
                                            }
                                          }
                                        >
                                          {agenda.cliente.desc}
                                        </span>
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <span
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {agenda.acao}
                                        </span>
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {agenda.idPedido && (
                                          <div
                                            style={{
                                              color: "#5f9f1a",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.clickPedido(agenda.idPedido)
                                            }
                                          >
                                            {" "}
                                            #{agenda.codPedido}{" "}
                                          </div>
                                        )}
                                        {!agenda.idPedido && <div> - </div>}
                                      </td>
                                      {agenda.status === "F" && (
                                        <td style={{ textAlign: "center" }}>
                                          {agenda.finalizadoSucesso
                                            ? "SIM"
                                            : "NÃO"}
                                        </td>
                                      )}
                                      {agenda.status === "P" && (
                                        <td style={{ textAlign: "center" }}>
                                          -
                                        </td>
                                      )}
                                      <td style={{ textAlign: "center" }}>
                                        {agenda.motivoFinalizacao
                                          ? agenda.motivoFinalizacao.desc
                                          : ""}
                                      </td>
                                      <td className="text-center d-flex flex-wrap">
                                        <div style={{ margin: "3px" }}>
                                          <i
                                            className="fa fa-eye"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.props.history.push(
                                                `/agenda-detalhe?id=${agenda._id}`
                                              )
                                            }
                                            id={`visualizar-agenda-${agenda._id}`}
                                          ></i>

                                          <UncontrolledTooltip
                                            placement="right"
                                            target={`visualizar-agenda-${agenda._id}`}
                                          >
                                            Visualizar agenda
                                          </UncontrolledTooltip>
                                        </div>
                                        {agenda.status === "P" && (
                                          <div style={{ margin: "3px" }}>
                                            <i
                                              className="fa fa-edit"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                this.props.history.push(
                                                  `/agenda-editar?id=${agenda._id}`
                                                );
                                              }}
                                              id={`editar-agenda-${agenda._id}`}
                                            ></i>

                                            <UncontrolledTooltip
                                              placement="right"
                                              target={`editar-agenda-${agenda._id}`}
                                            >
                                              Editar agenda
                                            </UncontrolledTooltip>
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>

                          <div className="paginacao">
                            <Pagination
                              prevPageText={<i className="fa fa-angle-left" />}
                              nextPageText={<i className="fa fa-angle-right" />}
                              firstPageText={
                                <i className="fa fa-angle-double-left" />
                              }
                              lastPageText={
                                <i className="fa fa-angle-double-right" />
                              }
                              activePage={this.state.paginacao.pagina}
                              itemsCountPerPage={this.state.paginacao.limite}
                              totalItemsCount={this.state.totalizador}
                              onChange={(pagina) => this.paginar(pagina)}
                              itemClass="page-item"
                              linkClass="page-link"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.agendas.length == 0 && this.state.pesquisa && (
                      <div className="card">
                        <div className="card-body">
                          <div className="table-responsive">
                            <div
                              className="col-lg-12"
                              style={{ textAlign: "center" }}
                            >
                              Não existe Agendas nesse periodo.
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <Modal isOpen={false} toggle={this.toggle}>
          <ModalHeader>Detalhe da agenda</ModalHeader>
          <ModalBody></ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={this.toggle}>
              Fechar
            </button>

            {/* <button
              className="btn btn-danger"
              onClick={() => this.abrirPaginaEditarContatos()}
            >
              Corrigir
            </button>
          */}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default RelatorioAgenda;
